// app/javascript/compcalc/components/DeathBenefits.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { currencyFormatter } from '../utils';


const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  wrapContent: {
    display: 'inline-block',
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textFieldAmount: {
    width: 280,
    // margin: 'auto',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  paperStretch: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class DeathBenefits extends React.PureComponent {

  constructor() {
    super();

    this.itemsYears = [
      (<MenuItem dense key={0} value={0}>01/01/1984</MenuItem>),
      (<MenuItem dense key={1} value={1}>01/01/1991</MenuItem>),
      (<MenuItem dense key={2} value={2}>07/01/1994</MenuItem>),
      (<MenuItem dense key={3} value={3}>07/01/1996</MenuItem>),
      (<MenuItem dense key={4} value={4}>01/01/2006</MenuItem>),
    ];

    this.itemsDependents = [
      [
        (<MenuItem dense key={0} value={0}>1 | 0</MenuItem>),
        (<MenuItem dense key={1} value={1}>2 or more | NA</MenuItem>),
        (<MenuItem dense key={2} value={2}>1 | 1 or more</MenuItem>),
        (<MenuItem dense key={3} value={3}>0 | 1 or more</MenuItem>),
      ],
      [
        (<MenuItem dense key={0} value={0}>1 | 0</MenuItem>),
        (<MenuItem dense key={1} value={1}>2 | NA</MenuItem>),
        (<MenuItem dense key={2} value={2}>3 or more | NA</MenuItem>),
        (<MenuItem dense key={3} value={3}>1 | 1 or more</MenuItem>),
        (<MenuItem dense key={4} value={4}>0 | 1 or more</MenuItem>),
      ]
    ];

    this.amounts = [
      [ "($70,000)",  "($95,000)",  "$70,000 + 4 * annual support ($95,000)",  "4 * annual support ($70,000)" ],
      [ "($95,000)",  "($115,000)", "$95,000 + 4 * annual support ($115,000)", "4 * annual support ($95,000)" ],
      [ "($115,000)", "($135,000)", "($150,000)", "$115,000 + 4 * annual support ($125,000)", "4 * annual support ($115,000)" ],
      [ "($125,000)", "($145,000)", "($160,000)", "$125,000 + 4 * annual support ($145,000)", "4 * annual support ($125,000)" ],
      [ "($250,000)", "($290,000)", "($320,000)", "$250,000 + 4 * annual support ($290,000)", "8 * annual support ($250,000)" ],
    ];

    this.state = {
      doi: 0,
      depsIndex: 0,
      deps: 0,
      amount: '0',
      isExpanded: false,
    };
  }

  componentDidMount() {
    this.calculate();
  }

  onTextExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  onSelectChange = (event) => {
    // console.log(event.target.name, event.target.value);
    this.setState({ [event.target.name]: event.target.value }, this.calculate); // Alternative componentDidUpdate().
  };

  calculate = () => {
    let depsIndex = this.state.doi >= 2 ? 1 : 0;
    let deps = this.state.deps < this.itemsDependents[depsIndex].length ? this.state.deps : this.itemsDependents[depsIndex].length-1
    this.setState({
      depsIndex: depsIndex,
      deps: deps,
      amount: this.amounts[this.state.doi][deps]
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid container spacing={1} className={classes.root} justifyContent="center">

        <Grid item xs={6} className={classes.alignCenter}>
          {/* Date of Injury */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Date of Injury</FormLabel>
              <Select
                value={this.state.doi}
                onChange={this.onSelectChange}
                input={<Input id="doi" name="doi" />}
                autoWidth
              >
                { this.itemsYears }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={6} className={classes.alignCenter}>
          {/* Dependents */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Dependents<br/>Total | Partial</FormLabel>
              <Select
                value={this.state.deps}
                onChange={this.onSelectChange}
                input={<Input id="deps" name="deps" />}
                autoWidth
              >
                { this.itemsDependents[this.state.depsIndex] }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={12} className={classes.alignCenter}>
          {/* Benefit (maximum) */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Benefit (maximum)</FormLabel>
              <TextField
                id="amount"
                value={this.state.amount}
                className={classes.textFieldAmount}
                margin="normal"
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={12} className={classes.alignCenter}>
          <Paper className={classes.paper}>
            <div className={classes.pre}>
              <Typography variant="body1">
                {dbText}
              </Typography>
              {this.state.isExpanded && (
                <Typography variant="body1">
                  {dbText1}
                </Typography>
              )}
              <div className={classes.alignRight}>
                <Button color="primary" onClick={this.onTextExpand}>
                  {this.state.isExpanded ? 'Less ...' : 'More ...'}
                </Button>
              </div>
            </div>
          </Paper>
        </Grid>

      </Grid>
    );
  }

};

export default withStyles(styles)(DeathBenefits);

const dbText = `1. Death benefits LC 4702(a). Death benefits are determined at the date of injury not date of death. LC 3501-3502.

2. Death benefits are paid in payments at the same rate as temporary disability unless otherwise ordered by WCAB except the minimum payment is $224.00 per week. LC 4702(b).

3. Rate of payment is the rate in effect at the date of injury and remains that rate for the first two years following the date of injury. After two years from the date of injury any payments are increased to the temporary total disability rate currently in effect at the date of payment. If 2/3 of weekly wage is above maximum the payment will increase to the maximum. Payment rate will continue to increase until 2/3 of weekly wage is below the maximum and then the payment rate will be constant at 2/3 of weekly wage. LC 4661.5 and Phillips v. Sacramento Municipal Utilities District. 63 Cal.Comp.Cas. 585.`;

const dbText1 = `
4. Temporary total disability maximum and minimum are increased yearly by SAW W. LC 4453(a)(1). Payments below maximum and above $224.00 are not increased yearly by COLA.

5. Where there is one or more totally dependent minor children, payment shall continue after the benefit is paid until the youngest child attains the age of 18 or until the death of a child physically or mentally incapacitated from earnings. For some minor children, payments continue until they are 19 if still attending high school or are receiving benefits as a child of an active member of a sheriff's office. LC 4703.5.

6. Maximum burial expenses 1/1/19-12/31/12 - $5,000; on or after I/1/13 - $10,000.00. LC 4701.

7. Dependents conclusively presumed wholly dependent under LC 3501:
(a) Minor child or a child of any age found to be physically or mentally incapacitated from earning who was either living with deceased parent or the deceased parent was legally liable at the time of injury.
(b) Spouse earning less than $30,000 in the preceding 12 months at time of death.

8. Where there are two or more total dependents there is no increase for partial dependents. LC 4702(a)(1).

9. If there are no total dependents, but one or more partial dependents, they are entitled to benefits. LC 4702(a)(A)-(B).

10. Temporary or permanent disability payments, if any, stop at death. Accrued and unpaid compensation is paid to the dependents. Accrued disability compensation is in addition to death benefits if the employment injury coinnbuted to or caused the death. LC 4700.

11. The period within which to commence proceedings for the collection of death benefits is one year from death where death occurs within one year of DOI; or one year from date of last furnishing of any benefits or one year from death where death occurs more than one year from DOI. No such proceedings may be commenced more than 240 weeks from the date of injury. LC 5406.`;
